module.exports = __webpack_public_path__ + "static/media/bg-home-top-right.f20f1d83.png";